import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0cc1746"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mt-10" }
const _hoisted_2 = {
  class: "m-4 text-3xl",
  "data-cy": "header-impressum"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-4" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Firmawortlaut"),
  /*#__PURE__*/_createTextVNode(" MovingLayers GmbH "),
  /*#__PURE__*/_createElementVNode("h2", null, "Unternehmensgegenstand"),
  /*#__PURE__*/_createTextVNode(" Beratung zu und Erstellung von geographischen Informationslösungen "),
  /*#__PURE__*/_createElementVNode("h2", null, "UID-Nummer"),
  /*#__PURE__*/_createTextVNode(" ATU 78786645 "),
  /*#__PURE__*/_createElementVNode("h2", null, "Firmenbuchnummer und Firmenbuchgericht"),
  /*#__PURE__*/_createTextVNode(" 593363v Handelsgericht Wien "),
  /*#__PURE__*/_createElementVNode("h2", null, "Firmensitz"),
  /*#__PURE__*/_createTextVNode(" Gumpendorfer Straße 67/9"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1060 Wien | Austria "),
  /*#__PURE__*/_createElementVNode("h2", null, "Kontaktdaten"),
  /*#__PURE__*/_createTextVNode(" Tel : +43 664 55 31 682"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" E-Mail : office@movinglayers.eu"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("h2", null, "WK-Mitgliedschaften"),
  /*#__PURE__*/_createTextVNode(" Mitglied der WKÖ, WK Wien, UBIT "),
  /*#__PURE__*/_createElementVNode("h2", null, "Anwendbare Rechtsvorschriften"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.ris.bka.gv.at/",
    target: "_blank",
    rel: "noopener"
  }, "http://www.ris.bka.gv.at/"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=10007517",
    target: "_blank",
    rel: "noopener"
  }, "Gewerbeordnung"),
  /*#__PURE__*/_createElementVNode("h2", null, "Aufsichts-/Gewerbebehörde"),
  /*#__PURE__*/_createTextVNode(" Magistratisches Bezirksamt 6. Bezirk Wien "),
  /*#__PURE__*/_createElementVNode("h2", null, "Online-Streitbeilegung"),
  /*#__PURE__*/_createTextVNode(" Verbraucher haben die Möglichkeit, Beschwerden an die Online-Streitbeilegungsplattform der EU zu richten: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://ec.europa.eu/odr",
    target: "_blank",
    rel: "noopener"
  }, "http://ec.europa.eu/odr"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Sie können allfällige Beschwerde auch an die oben angegebene E-Mail-Adresse richten. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.movinglayers.eu/wordpress/wp-content/uploads/2024/07/AGB-MovingLayers.pdf",
    target: "_blank",
    rel: "noopener"
  }, "AGB-MovingLayers.pdf"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Unser Eintrag im Firmen A-Z der WKO: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://firmen.wko.at/movinglayers-gmbh/wien/?firmaid=ac12a72a-c780-4ac8-a1cf-6ff126c41e1c",
    target: "_blank",
    rel: "noopener"
  }, "MovingLayers GmbH")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserDialogButton = _resolveComponent("UserDialogButton")!
  const _component_toolbar = _resolveComponent("toolbar")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_toolbar, { title: _ctx.toolbarTitle }, _createSlots({ _: 2 }, [
        (_ctx.isLoggedIn)
          ? {
              name: "trailing",
              fn: _withCtx(() => [
                _createVNode(_component_UserDialogButton)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.t('toolbar.impressum')), 1),
            _hoisted_3
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}